export const FORGET_PASS_USER_ID_KEY = "user_id_forget_pass";
export const FORGET_PASS_PHONE_KEY = "phone_forget_pass";
